import React, { useState, useEffect, useRef, useContext } from 'react';
import { coreAxios } from "utilities/axios";
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FiEdit } from "react-icons/fi";
import { CommonButton } from "components/Buttons/Buttons";
import { MasterButton } from "components/Buttons/MasterButton";
import { Card } from 'primereact/card';


//NEW
import AuthContext from  "../../context/AuthContext";
import { InputField } from "components/InputField/Input";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetRequisitionItemsForWorkOrder } from 'services/requisition/requisition.service';

import { GetWorkOrderListByShop, AddWorkOrder, UpdateWorkOrder, DeleteWorkOrder, GetWorkOrderItems, GetWorkOrderDetail } from 'services/workorder/workOrder.service'
import { GetRequisitionNames } from 'services/dropdown/dropdown.service';
import { GetBrands } from 'services/other/brand.service';


import { Table } from 'components/Table/Table';
import { TableWorkOrderDetail } from 'components/Table/TableWorkOrderDetail';
import { TableForm } from 'components/Table/TableForm'
import { NameColumn, TextColumn, CompleteStatusColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { WorkOrderValidationSchema } from 'utilities/ValidationSchema/WorkOrder/WorkOrderValidationSchema';
import useProductDataTable from './hook/useProductDataTable';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const WorkOrder = () => {

    const { workOrderList, workOrderListLoading } = useSelector((state) => state.workOrderByShopList);
    const { workOrderAdd, workOrderAddLoading } = useSelector((state) => state.workOrderAdd);
    const { workOrderUpdate, workOrderUpdateLoading } = useSelector((state) => state.workOrderUpdate);
    const { deleteWorkOrder } = useSelector((state) => state.deleteWorkOrder);
    const { workOrderDetail, workOrderDetailLoading } = useSelector((state) => state.workOrderDetail);


    const { workOrderItems, workOrderItemsLoading } = useSelector((state) => state.workOrderItems);
    const { requisitionItemsForWorkOrder, requisitionItemsForWorkOrderLoading } = useSelector((state) => state.requisitionItemsForWorkOrderList);

    const [autoRequisitionFilteredValue, setAutoRequisitionFilteredValue] = useState([]);
    const [date, setDate] =useState(new Date());

    const { requisitionNameList, requisitionNamesLoading } = useSelector((state) => state.requisitionNames);
    const { brandList } = useSelector((state) => state.brandList);


    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [showDetail, setShowDetail] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const { user } = useContext(AuthContext);

    const [ requisitionID, setRequisitionId ] = useState();
    const [ workOrderDate, setWorkOrderDate ] = useState();
    const [ paymentDate, setPaymentDate ] = useState();
    const [ remark, setRemark ] = useState();


    // * intitial value for create Work order state
    const createInitialValue = {
        id: 0,
        requisition: requisitionNameList?.find((value) => value.id === requisitionID) || "",
        order_date: workOrderDate || date,
        payment_date: paymentDate || date,
        remark: remark || "",
        order_items: requisitionItemsForWorkOrder?.map((value) => {
            return {
                ...value,
                unit_price: 0,
                discount: 0,
            };
        }) || [
            {
                id: 0,
                name: "",
                order_quantity: 1,
                unit_price: 0,
                discount: 0,
                brand: "",
            },
        ],
    };

    const updateInitialValue = {
        id: updateData?.id,
        requisition: requisitionNameList?.find((value) => value.id === updateData?.requisition) || "",
        order_date: new Date(updateData?.order_date),
        payment_date: new Date(updateData?.payment_date),
        remark: updateData?.remark,
        order_items: workOrderItems?.map((value) => {
            return {
                ...value,
                brand: brandList?.find((item) => item.id === value.brand),
            };
        }) || [
            {
                id: 0,
                name: "",
                quantity: 1,
                unit_price: 1,
                discount: 0,
                brand: "",
            },
        ],

    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: WorkOrderValidationSchema, // * yup schema validation
        onSubmit: (values) => {

            const modifiedData = {
                ...values,
                requisition: values.requisition?.id || 0,
                order_items: values.order_items.map((value) => {
                    return{
                        ...value,
                        brand: value.brand?.id,
                    }
                })
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns } = useProductDataTable(
        formik, 
        setShowForm, 
        setUpdateData,
    );


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();


    const updateWorkOrder = (workOrder) => {
        dispatch(GetRequisitionNames({'shop': user?.shop_id, 'status': 'True'}));
        setShowForm(true); // * set the form to true
        dispatch(GetWorkOrderItems(workOrder?.id))
        setUpdateData(workOrder);
    };

    const workOrderDetails = (work_order) => {

        setShowDetail(true); // * set the form to true
        dispatch(GetWorkOrderDetail(work_order?.id))
        // setUpdateData(chalan);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteWorkOrder(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetWorkOrderListByShop(user?.shop_id));
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateWorkOrder(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddWorkOrder(data)).then(() => {
            hideModal();
            return
        });
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowDetail(false);
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();

        dispatch(GetRequisitionItemsForWorkOrder(0))

        setRequisitionId()
        setWorkOrderDate()
        setPaymentDate()
        setRemark()
    };

    useEffect(() => {
        dispatch(GetWorkOrderListByShop(user?.shop_id));
        dispatch(GetRequisitionNames({'shop': user?.shop_id, 'status': 'False'}));
        dispatch(GetBrands());
    }, [workOrderAdd, workOrderUpdate, deleteWorkOrder]);


    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "Work Order", sortableBody: NameColumn },
        { field: "requisition_name", header: "Requisition", sortableBody: TextColumn },
        { field: "order_local_date", header: "Order Date", sortableBody: TextColumn },
        { field: "payment_local_date", header: "Payment Date", sortableBody: TextColumn },
        { field: "chalan_status", header: "Chalan Status", sortableBody: CompleteStatusColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
    ];

    const detailTableColumns = [
        { field: "name", header: "Item", sortableBody: NameColumn },
        { field: "uom", header: "Uom", sortableBody: TextColumn },
        { field: "brand_name", header: "Brand", sortableBody: TextColumn },
        { field: "order_quantity", header: "Order Quantity", sortableBody: TextColumn },
        { field: "unit_price", header: "Unit Price", sortableBody: TextColumn },
        { field: "discount", header: "Discount", sortableBody: TextColumn },
        { field: "total_unit_price", header: "Total", sortableBody: TextColumn },
    ];

    const searchRequsition = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && requisitionNameList !== undefined) {
                setAutoRequisitionFilteredValue([...requisitionNameList]);
            } else {
                setAutoRequisitionFilteredValue(
                    requisitionNameList?.filter((requisition) => {
                        return requisition.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };


    const downloadRequisition = async (rowData) => {
        const url = `${BASE_URL}/api/work/order/download/${rowData.id}/`;
        try {
            const response = await coreAxios.get(url, {
              responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `work-order-${rowData.name}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
          console.log(error)
        }
    };

    function loadRequsitionItems(e) {
        e.preventDefault();

        dispatch(GetRequisitionItemsForWorkOrder(formik.values['requisition']['id']))

        setRequisitionId(formik.values['requisition']['id'])
        setWorkOrderDate(formik.values['order_date'])
        setPaymentDate(formik.values['payment_date'])
        setRemark(formik.values['remark'])
    }


    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "requisition",
            name: "requisition",
            type: "select",
            labelFor: "Requisition",
            label: "Select Requisition",
            required: true,
            disabled: updateData ? true : false,
            className: "col-12 md:col-3",
            OnChange: (e) => loadRequsitionItems(e),
            autoFilteredValue: autoRequisitionFilteredValue,
            autoCompleteMethod: searchRequsition,
            selectedAutoValue: requisitionNameList,

        },
        {
            id: "order_date",
            name: "order_date",
            value: "order_date",
            type: "date",
            labelFor: "Order Date",
            label: "Order Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "payment_date",
            name: "payment_date",
            value: "payment_date",
            type: "date",
            labelFor: "Payment Date",
            label: "Payment Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "remark",
            name: "remark",
            value: "remark",
            type: "text",
            labelFor: "Remark",
            label: "Remark",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-3",
        },
        {
            id: 'button',
            name: 'Load Requisition Items',
            type: 'button',
            label: 'Load Requisition Items',
            className: "col-12 md:col-2",
            btnColor: 'secondary',
            disabled: updateData,
            onClick: loadRequsitionItems,
            loading: requisitionItemsForWorkOrderLoading,
        }
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        user.user_type === 'ADMIN' ? 
                        <>
                            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => updateWorkOrder(rowData)} />
                            <Toast ref={toast} />
                            <ConfirmPopup />
                            <Button 
                                onClick={(e) => {
                                    DeleteModal(e, rowData.id);
                                }} 
                                icon="pi pi-trash" 
                                className="p-button-rounded p-button-warning mr-2"
                                disabled= {rowData.chalan_status === true ? true : false}
                            />
                        </> : <></>
                    }
                    

                    <Button 
                        icon="pi pi-list" 
                        className="p-button-outlined p-button-info mr-2" 
                        onClick={(e) => {
                            workOrderDetails(rowData)
                        }}
                    />
                    
                    <Button 
                        icon="pi pi-download" 
                        className="p-button-rounded p-button-secondary" 
                        onClick={(e) => {
                            downloadRequisition(rowData)
                        }}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                //data
                tableHeaderName="Work Order Details"
                tableColumns={tableColumns}
                data={workOrderList}
                loading={workOrderListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <Dialog 
                visible={showForm} 
                style={{ width: "1400px" }} 
                header={`${updateData ? "Update" : "Create"} Work Order`} 
                className="p-fluid" 
                onHide={hideModal} 
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                    {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                            
                        <div key={id} className={`p-field ${className}`} >
                            <InputField
                                id={id}
                                type={type}
                                required={required}
                                name={name}
                                errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                label={label}
                                labelFor={labelFor}
                                rows={rows}
                                value={formik.values[name]}
                                autoCompleteMethod={autoCompleteMethod}
                                autoFilteredValue={autoFilteredValue}
                                onChange={(...args) => {
                                    !onChange && formik.handleChange(...args);
                                    onChange?.(...args);
                                }}
                                onBlur={onBlur}
                                onClose={() => formik.setErrors({})}
                                {...rest}
                            />
                        </div>
                    ))}


                    <div className="col-12">
                        <div className="w-full">
                            <TableForm
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.order_items}
                                loading={requisitionNamesLoading}
                                dataKey="productID"
                                type="workorder"
                                actionButtonWidth={10}
                            />
                        </div>
                    </div>
                    <MasterButton resetForm={resetForm} update={updateData} loading={requisitionNamesLoading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                </form>
            </Dialog>

            <Dialog 
                visible={showDetail} 
                style={{ width: "1400px" }} 
                // header="Chalan Details"
                className="p-fluid" 
                onHide={hideModal} 
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                {
                    workOrderDetail && 
                    (
                    <div className='grid'>
                        <div className='col-4'>

                        </div>
                        <div className='col-4'>
                            <Card title="Work Order Details" style={{ height: '180px', marginRight: '10px' }}>
                                <div>
                                    <strong>Work Order ID: </strong> {workOrderDetail.name}
                                </div>
                                <div>
                                    <strong>Requisition ID: </strong> {workOrderDetail.requisition_name}
                                </div>
                                <div>
                                    <strong>Order Date: </strong> {workOrderDetail.order_local_date}
                                </div>
                                <div>
                                    <strong>Payment Date: </strong> {workOrderDetail.payment_local_date}
                                </div>
                                <div>
                                    <strong>Chalan Status: </strong> {workOrderDetail?.chalan_status ? "Complete" : "Incomplete"}
                                </div>
                                <div>
                                    <strong>Remark: </strong> {workOrderDetail?.remark}
                                </div>
                            </Card>
                        </div>
                        <div className='col-4'>

                        </div>
                    </div>
                    )
                }
                
                <Divider align="center">
                    <span className="p-tag">Work Order Items Details</span>
                </Divider>

                <TableWorkOrderDetail
                    tableColumns={detailTableColumns}
                    data={workOrderDetail.work_order}
                    loading={workOrderDetailLoading}
                    dataKey="id"
                />
            </Dialog>
        </>
    );
};

export default WorkOrder;
